import useSWR, { SWRResponse } from 'swr';
import { SearchCriteria } from '../../../providers/api/dtos/searchCriteria';
import { getSearchCriteria } from '../../../providers/api/search-criteria/searchCriteriaProvider';

export const SEARCH_CRITERIA_RID = '/search-criteria/';

export default function useSearchCriteria(id?: number): SWRResponse<SearchCriteria, Error> {
  return useSWR(id ? [SEARCH_CRITERIA_RID, id] : null, () => getSearchCriteria(id!));
}
